import script from "./EmailingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailingForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__